const { Button, ButtonGroup, Popover } = wp.components;

const { __ } = wp.i18n;
const { useState } = wp.element;

function ButtonWithConfirm({
	className,
	onConfirm = null,
	buttonText = __('Remove', 'conditional-blocks'),
	PopoverText = __('Are you sure? This cannot be undone.', 'conditional-blocks'),
	confirmText = __('Yes, delete', 'conditional-blocks'),
	cancelText = __('Cancel', 'conditional-blocks'),
	isSecondary = false,
	isPrimary = false,
	isTertiary = false
}) {
	const [isVisible, setIsVisible] = useState(false);

	const handleConfirm = () => {
		if (typeof onConfirm === 'function') {
			onConfirm();
		}
		// setIsVisible(false);
	};

	return (
		<Button
			className={className ?? 'conditional-blocks-builder-modal__delete_button'}
			icon='remove'
			iconSize={15}
			isSmall
			isTertiary={isTertiary}
			isSecondary={isSecondary}
			isPrimary={isPrimary}
			isDestructive
			onClick={() => {
				setIsVisible(!isVisible);
			}}
		>
			{buttonText}
			{isVisible && (
				<Popover
					onClose={() => {
						setIsVisible(false);
					}}
					onFocusOutside={() => {
						setIsVisible(false);
					}}
					noArrow={false}
					className='conditional-blocks-builder-modal__popover'
				>
					<div className='conditional-blocks-builder-modal__row'>{PopoverText}</div>
					<div className='conditional-blocks-builder-modal__row'>
						<ButtonGroup className='conditional-blocks-builder-modal__button_group'>
							<Button isSecondary isDestructive onClick={handleConfirm}>
								{confirmText}
							</Button>
							<Button
								isSecondary
								onClick={() => {
									setIsVisible(false);
								}}
							>
								{cancelText}
							</Button>
						</ButtonGroup>
					</div>
				</Popover>
			)}
		</Button>
	);
}

export default ButtonWithConfirm;
